import { render, staticRenderFns } from "./setPass.vue?vue&type=template&id=7ab29d69&scoped=true"
import script from "./setPass.vue?vue&type=script&lang=js"
export * from "./setPass.vue?vue&type=script&lang=js"
import style0 from "./setPass.vue?vue&type=style&index=0&id=7ab29d69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab29d69",
  null
  
)

export default component.exports